<div id="{{id}}" class="{{#if hideCriteriaFirstTime}}hidden{{/if}}">
    <field-item item="criteriaFormModel">
        <field-hcombo id="criteria-selectByType" name="type" label="" {options}="typeOptions"></field-hcombo>

        <field-radios label="" name="cpcProtocolKind" {options}="cpcProtocolKinds" {visible}="states.cpcProtocolKind"></field-radios>

    </field-item>
</div>
